// Module
var code = "<template class=\"ess-logo fa-stack\"> <i class=\"ess-hms-logo essette-icons fa-stack-1x\"></i> <i class=\"ess-essette-logo essette-icons fa-stack-1x logo-2\" role=\"img\" aria-label=\"Essette\"></i> </template> ";
// Exports
module.exports = code;